import axios from 'axios';

let prefix = "/dashboard"

const DashboardApi = {
	getMonthlyVolume(payload){
		return axios.get( prefix + "/monthly-volume/" + payload)
	},
	getTopContributors(payload, metric, stream, category_id){
		return axios.get( prefix + "/top-contributors/" + payload, { params: { metric, stream, category_id } })
	},
	getRecyclablesBreakdown(payload, type, metric){
		return axios.get( prefix + "/recyclables-breakdown/" + payload, { params: { type, metric } })
	},
	getYtdByCategory(payload){
		return axios.get( prefix + "/ytd-by-category", { params: payload })
	},
	getYtdSummary(payload){
		return axios.get( prefix + "/ytd-summary", { params: payload })
	},
	getCo2EmissionByYear(payload){
		return axios.get( prefix + "/co2-emission-by-year", { params: payload })
	},
	getUbcCollection(payload){
		return axios.get( prefix + "/ubc-collection", { params: payload })
	},
	getLocationUbcDetails(locationId){
		return axios.get( prefix + "/location-ubc-details/" + locationId)
	},
	getTenantCollectionSummary(year, stream, category_id){
		return axios.get( prefix + "/tenant-collection-summary/" + year, { params: { stream, category_id } })
	},
	// Dropdown options: Recyclables, each waste category by title, All waste, All.
	getStreamOptions(){
		return axios.get( prefix + "/stream-options")
	},
	// recyclable / (recyclable + waste), by month for the given year.
	getRecyclingRate(year){
		return axios.get( prefix + "/recycling-rate/" + year)
	},
}

export default DashboardApi;